import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-relative light-light-background max-size"
}
const _hoisted_2 = { class: "image-container app-image center-x px-5 py-3" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "fw-b fs-larger" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "octo-gradient-purple-color fw-b fs-larger" }
const _hoisted_8 = ["innerHTML"]

import { IonCol, IonGrid, IonIcon, IonRow, isPlatform } from "@ionic/vue";
import { newspaperOutline } from "ionicons/icons";
import { isApp, isNativeApp } from "@/functions/enviroment";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { InformationInterfaceProps } from "@/types/props/modal";
import { computed, onBeforeUnmount, ref, watch } from "vue";
import { downloadFileApi } from "@/api-connectors/file";
import NewsModalProductInterface from "@/components/modal/NewsModalProductInterface.vue";
import FlexibleProductInterface from "@/components/modal/FlexibleProductInterface.vue";
import { ProductMaster, Supplier } from "@/types/supplier";
import { InformationInterfaceEmits } from "@/types/emits/component";
import { AUDIENCE_TYPE, INFORMATION_TYPE, PROMOTION_TYPE } from "@/types/enum/notification";
import { useSupplierStore } from "@/stores/suppliers";
import ProductAvailability from "@/components/various/ProductAvailability.vue";

import { Keyboard, KeyboardResize } from '@capacitor/keyboard';


export default /*@__PURE__*/_defineComponent({
  __name: 'InformationInterface',
  props: {
    information: {},
    cart: { type: Boolean },
    itemPlaceholder: { type: Boolean }
  },
  emits: ["add", "addPackage"],
  setup(__props: any) {

const props = __props


const supplierStore = useSupplierStore()

const evaluateAmount = (): number => {
    if (!props.information || !availableProducts.value?.length) return 1

    const firstProduct = availableProducts.value[0]

    if (!firstProduct) return 1

    return (firstProduct.recommendedAmount ?? firstProduct.stepAmount) ?? 1
}

// remove product variant from the selection if there are no harmonized product by any supplier of this location
const availableProducts = computed<ProductMaster[] | undefined>(() => props.information?.products.filter((i: ProductMaster) => i.availableBy?.length))

const amount = ref<number>(evaluateAmount())
const product = ref<ProductMaster | undefined>(availableProducts.value?.length ? availableProducts.value[0] : undefined)

const hasProduct = computed<boolean>(() => props.information?.products?.length > 0)

const suppliers = computed<Supplier[]>(() => {
    if (!props.information) return []

    if (props.information.audience.type === AUDIENCE_TYPE.ALL) return supplierStore.allSuppliers

    const informationSuppliers: Supplier[] = []
    for (const supplierId of props.information.audience.participatingSupplierIds) {
        const participatingSupplier = supplierStore.supplierById(supplierId)
        if (!participatingSupplier) continue

        // Remove suppliers without harmonised products from the 'Available by' section
        // Attention! Remove only from promotions! Product suggestions should still include suppliers without harmonised products.
		const availableProductsBySuppliers = new Set(availableProducts.value?.map((i) => i.availableBy).flat());
		if (props.information.kind === INFORMATION_TYPE.PROMOTION && !availableProductsBySuppliers.has(participatingSupplier.id)) continue;
        
        informationSuppliers.push(participatingSupplier)
    }

    return informationSuppliers
})

const productSuppliers = computed<Supplier[]>(() => {
    if (!hasProduct.value) return []

    if (!product.value?.availableBy) return []

    const informationSuppliers: Supplier[] = []
    for (const supplierId of product.value.availableBy) {
        const participatingSupplier = supplierStore.supplierById(supplierId)
        if (!participatingSupplier) continue
        informationSuppliers.push(participatingSupplier)
    }
    return informationSuppliers
})

watch(() => props.information.id, () => {
    product.value = availableProducts.value?.length ? availableProducts.value[0] : undefined
    amount.value = evaluateAmount()
})

/* BUG-FIX: KeyboardResize issue on iOS */

let keyboardShowListener: any;

async function setupKeyboardListener() {
    Keyboard.setResizeMode({ mode: KeyboardResize.Body });
    keyboardShowListener = await Keyboard.addListener('keyboardDidShow', () => {
        // Scroll the active element into view
        document.activeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
}

if (isNativeApp && isPlatform('ios')) setupKeyboardListener()

onBeforeUnmount(() => {
    if (isNativeApp && isPlatform('ios')) {
        keyboardShowListener.remove();
        Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    }
})

const verticalVersion = ref<boolean>(isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('orientationchange', () => verticalVersion.value = isApp() && window.matchMedia("(orientation: portrait)").matches)
window.addEventListener('resize', () => verticalVersion.value = isApp() && window.matchMedia("(orientation: portrait)").matches)

return (_ctx: any,_cache: any) => {
  return (verticalVersion.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.information.image && __props.information.image.url)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "",
                src: __props.information.image.url,
                class: "information-image"
              }, null, 8, _hoisted_3))
            : (hasProduct.value || props.itemPlaceholder)
              ? (_openBlock(), _createBlock(_unref(IonIcon), {
                  key: 1,
                  src: "/assets/icon/item.svg",
                  class: "coral-coral-color information-image",
                  style: {"height":"100%","width":"100%"}
                }))
              : (_openBlock(), _createBlock(_unref(IonIcon), {
                  key: 2,
                  icon: _unref(newspaperOutline),
                  class: "coral-coral-color information-image",
                  style: {"height":"100%","width":"100%"}
                }, null, 8, ["icon"]))
        ]),
        _createVNode(_unref(IonGrid), { class: "light-light-background purple-purple-color" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.information.title), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (__props.information.body)
              ? (_openBlock(), _createBlock(_unref(IonRow), {
                  key: 0,
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          innerHTML: __props.information.body
                        }, null, 8, _hoisted_5)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (suppliers.value.length && product.value && __props.information.kind === _unref(INFORMATION_TYPE).PROMOTION && __props.information.promotionType === _unref(PROMOTION_TYPE).BONUS_FLEXIBLE)
              ? (_openBlock(), _createBlock(FlexibleProductInterface, {
                  key: 1,
                  information: __props.information,
                  audience: suppliers.value,
                  onAddPackage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('addPackage', $event)))
                }, null, 8, ["information", "audience"]))
              : (suppliers.value.length && product.value && hasProduct.value && (__props.information.kind === _unref(INFORMATION_TYPE).PRODUCT_PRESENTATION || __props.information.kind === _unref(INFORMATION_TYPE).PROMOTION))
                ? (_openBlock(), _createBlock(NewsModalProductInterface, {
                    key: 2,
                    modelValue: product.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((product).value = $event)),
                    amount: amount.value,
                    "onUpdate:amount": _cache[2] || (_cache[2] = ($event: any) => ((amount).value = $event)),
                    information: __props.information,
                    cart: __props.cart,
                    onAdd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('add',{product: product.value, amount: amount.value})))
                  }, null, 8, ["modelValue", "amount", "information", "cart"]))
                : _createCommentVNode("", true),
            _createVNode(_unref(IonRow), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "center" }, {
                  default: _withCtx(() => [
                    (__props.information.file)
                      ? (_openBlock(), _createBlock(ButtonBase, {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(downloadFileApi)({ fileRoute: __props.information.file.url, fileName: __props.information.file.name })))
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode(" Download ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : (__props.information)
      ? (_openBlock(), _createBlock(_unref(IonGrid), {
          key: 1,
          class: "purple-purple-color d-flex flex-d-c flex-grow-1 max-size",
          style: _normalizeStyle(!_unref(isApp)() ? 'padding-inline: 4.25rem;' : '')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonRow), { class: "max-height" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonCol), { class: "center max-height-100" }, {
                  default: _withCtx(() => [
                    (__props.information.image && __props.information.image.url)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "",
                          src: __props.information.image.url,
                          class: "information-image"
                        }, null, 8, _hoisted_6))
                      : (hasProduct.value || props.itemPlaceholder)
                        ? (_openBlock(), _createBlock(_unref(IonIcon), {
                            key: 1,
                            src: "/assets/icon/item.svg",
                            class: "coral-coral-color information-image",
                            style: {"height":"100%","width":"100%"}
                          }))
                        : (_openBlock(), _createBlock(_unref(IonIcon), {
                            key: 2,
                            icon: _unref(newspaperOutline),
                            class: "coral-coral-color information-image",
                            style: {"height":"100%","width":"100%"}
                          }, null, 8, ["icon"]))
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCol), { class: "max-height-100 overflow-auto center-y-safe" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass({'center flex-d-c max-width': hasProduct.value })
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass({'max-width width-max-400': hasProduct.value })
                      }, [
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(__props.information.title), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  innerHTML: __props.information.body
                                }, null, 8, _hoisted_8)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (suppliers.value.length && product.value && __props.information.kind === _unref(INFORMATION_TYPE).PROMOTION && __props.information.promotionType === _unref(PROMOTION_TYPE).BONUS_FLEXIBLE)
                          ? (_openBlock(), _createBlock(FlexibleProductInterface, {
                              key: 0,
                              information: __props.information,
                              audience: suppliers.value,
                              onAddPackage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('addPackage', $event)))
                            }, null, 8, ["information", "audience"]))
                          : (suppliers.value.length && product.value && hasProduct.value && (__props.information.kind === _unref(INFORMATION_TYPE).PRODUCT_PRESENTATION || __props.information.kind === _unref(INFORMATION_TYPE).PROMOTION))
                            ? (_openBlock(), _createBlock(NewsModalProductInterface, {
                                key: 1,
                                modelValue: product.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((product).value = $event)),
                                amount: amount.value,
                                "onUpdate:amount": _cache[7] || (_cache[7] = ($event: any) => ((amount).value = $event)),
                                information: __props.information,
                                cart: __props.cart,
                                onAdd: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('add',{product: product.value, amount: amount.value})))
                              }, null, 8, ["modelValue", "amount", "information", "cart"]))
                            : _createCommentVNode("", true),
                        _createVNode(_unref(IonRow), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonCol), { class: "center" }, {
                              default: _withCtx(() => [
                                (__props.information.file)
                                  ? (_openBlock(), _createBlock(ButtonBase, {
                                      key: 0,
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(downloadFileApi)({ fileRoute: __props.information.file.url, fileName: __props.information.file.name })))
                                    }, {
                                      default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                        _createTextVNode(" Download ", -1)
                                      ]))]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 2)
                    ], 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true)
}
}

})